import {IStateStore}         from '../../ap-interface/interfaces/store';
import {Store}               from '../index';
import {Injectable}          from '@angular/core';
import {
  NetTypes,
  RequestNewPassword,
  RequestNewPasswordFail,
  RequestNewPasswordSuccess,
  SetNewPassword,
  SetNewPasswordFail,
  SetNewPasswordSuccess
}                            from 'invoker-transport';
import {LoginStore}          from './login.store';
import {LanguageStore}       from '../translation/language.store';
import {RouterStore}         from '../router/router.store';
import {NotifyStore}         from '../dialog/notify.store';
import {SafeBehaviorSubject} from 'ts-tooling';
import IApValidationResult = Data.Api.Validation.IApValidationResult;
import {ApSignalrService}    from '../../ap-core/services/ap-signalr.service';
import {ApBase64Util}        from '../../ap-utils/static/ap-base64-util';
import {debounceTime}        from 'rxjs/operators';
import {APP_CONFIGURATION}   from '../../ap-core/config';

interface IPasswordStore extends IStateStore<any> {

}

@Injectable({providedIn: 'root'})
export class PasswordStore extends Store<IPasswordStore> {
  constructor(public backend: ApSignalrService,
              private languageStore: LanguageStore,
              private loginStore: LoginStore,
              private routerStore: RouterStore,
              private notifyStore: NotifyStore) {
    super(backend, {
      loaded: false,
      loading: false,
      data: [],
    });

    backend.registerObservable(SetNewPasswordSuccess).subscribe(d => {
      const message = {
        DisplayTimeout: 10,
        Level: Data.Api.Validation.ApValidationLevel.Success,
        ErrorKey: d.Data
      } as IApValidationResult;
      this.notifyStore.addMessage(message);
      this.loginStore.Mutate(s => s.login.isSetPassword, () => true);
      setTimeout(() => this.routerStore.navigateToLogin(), 1000);
      this.SetLoadFinishState();
    });
    backend.registerObservable(RequestNewPasswordFail).subscribe(d => {
      const message = {
        DisplayTimeout: 10,
        Level: Data.Api.Validation.ApValidationLevel.Error,
        ErrorKey: d.Data
      } as IApValidationResult;
      this.notifyStore.addMessage(message);
      this.SetLoadFinishState();
      this.loginStore.Mutate(s => s.login.isSetPassword, () => false);
    });
    backend.registerObservable(SetNewPasswordFail).subscribe(d => {
      const message = {
        DisplayTimeout: 10,
        Level: Data.Api.Validation.ApValidationLevel.Error,
        ErrorKey: d.Data
      } as IApValidationResult;
      this.notifyStore.addMessage(message);
      this.SetLoadFinishState();
      this.loginStore.Mutate(s => s.login.isSetPassword, () => false);
    });
    backend.registerObservable(RequestNewPasswordSuccess).subscribe(async d => {
      const message = {
        DisplayTimeout: 10,
        Level: Data.Api.Validation.ApValidationLevel.Success,
        ErrorKey: d.Data
      } as IApValidationResult;
      this.notifyStore.addMessage(message);
      this.SetLoadFinishState();
      this.Mutate(s => s.data, () => d.Data);
      setTimeout(() => this.routerStore.navigateToPasswordRecovery(), 1000);
    });
    this.AfterDatabaseUpdate.pipe(debounceTime(APP_CONFIGURATION.StoreMutateDebounce)).subscribe(() => this.ReloadSource());
  }

  get PasswordLoading$(): SafeBehaviorSubject<boolean> {
    return this.Listen(s => s.loading);
  }

  /**
   * request a new Password per Email
   */
  forgotPassword(emailAddress: string): void {
    this.SetLoadState();
    this.DispatchBackend(new RequestNewPassword([
      {Name: 'emailAddress', Type: NetTypes.STRING, Value: emailAddress || ''},
      {
        Name: 'cultureInfo',
        Type: NetTypes.STRING,
        Value: this.languageStore?.SelectedLanguage?.Key !== null ? this.languageStore?.SelectedLanguage?.Key : 'en'
      },
    ]));
  }

  /**
   * set a new Password by Activation Key
   */
  setPassword(activationKey: string, password: string): void {
    this.SetLoadState();
    this.DispatchBackend(new SetNewPassword([
      {Name: 'activationKey', Type: NetTypes.STRING, Value: activationKey},
      {
        Name: 'passwordHash',
        Type: NetTypes.STRING,
        Value: ApBase64Util.stringToBase64(password)
      },
      {
        Name: 'cultureInfo',
        Type: NetTypes.STRING,
        Value: this.languageStore?.SelectedLanguage?.Key !== null ? this.languageStore?.SelectedLanguage?.Key : 'en'
      },
    ]));
  }
}
